export default {
    doesRequireOtp: 'auth/doesRequireOtp',
    login: 'auth/token',
    resetRequest: 'auth/reset',

    setPassword: 'auth/setPassword', 
    verifyReset: 'auth/verifyReset',
    verifyReCaptcha: 'auth/verifyReCaptcha',    

    //OTP
    //////////////////////////

    //MFA
    addMFA: 'auth/addMFA', 
    enableMFA: 'auth/enableMFA', 
    removeMFA: 'auth/removeMFA',
    testMFA: 'auth/testMFA',

    //SMS
    addSMSAuth: 'auth/addSMSAuth',
    removeSMSAuth: 'auth/removeSMSAuth',
    sendSMSOtp: 'auth/smsOtp',
    validateSMSOtp: 'auth/validateSMSOtp',
    sendTestOtpSMS: 'auth/sendTestOtpSMS',

    //EMAIL
    addEmailAuth: 'auth/addEmailAuth',
    removeEmailAuth: 'auth/removeEmailAuth',
    sendEmailOtp: 'auth/emailOtp',
    validateEmailOtp: 'auth/validateEmailOtp',
    sendTestOtpEmail: 'auth/sendTestOtpEmail',

};
